// extracted by mini-css-extract-plugin
module.exports =  {"label":"O8sayit","note":"wPXvhyl"};